import { Component, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";

import { MainConfig } from "@atenea-cms";
import { AwardService } from "../shared";

@Component({
  selector: "award-list",
  templateUrl: "./award-list.component.html",
  styleUrls: ["./award-list.component.scss"],
  host: { class: "atn-list-crud" },
})
export class AwardListComponent implements OnInit {
  constructor(
    private titleService: Title,
    private mainConfig: MainConfig,
    public dataService: AwardService
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Premios - " + this.mainConfig.cmsName);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/awards/award-list/award-list.component.ts